// src/api/userApi.js
import api from "./axios";

export const getUsers = async ({
  page = 1,
  page_size = 100,  
  search,
  role,
  zone_code,
  circle_code,
  div_code,
  subdiv_code,
  is_active,
} = {}) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("page_size", page_size);
  if (search?.trim()) params.append("search", search.trim());

  if (role && role !== "All")
    params.append("role", role);

  if (zone_code && zone_code !== "All")
    params.append("zone_code", zone_code);

  if (circle_code && circle_code !== "All")
    params.append("circle_code", circle_code);

  if (div_code && div_code !== "All")
    params.append("div_code", div_code);

  if (subdiv_code && subdiv_code !== "All")
    params.append("subdiv_code", subdiv_code);

  if (is_active !== undefined)
    params.append("is_active", is_active);

  const response = await api.get(`/users/users/?${params.toString()}`);

  return response.data;
};

export const createUser = async (userData) => {
  const formData = new FormData();
  
  Object.keys(userData).forEach(key => {
    if (userData[key] !== undefined && userData[key] !== null) {
      formData.append(key, userData[key]);
    }
  });

  const response = await api.post("/users/create-user/", formData);
  return response.data;
};
export const updateUser = async (id, userData) => {
  const response = await api.patch(
    `/users/profile/${id}/`,
    userData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const deleteUser = async (id) => {
  return api.delete(`/users/profile/${id}/`);
};